import * as Handlebars  from 'handlebars/runtime';
import Config           from '../../common/model/Config';
import Provider         from '../../common/model/Provider';
import { device }       from '../../common/utils/deviceCheck';
import { providerChk }  from '../../common/utils/provider.id.check';

function fnSelected(){
    Handlebars.registerHelper('selected', function(c1, c2) {
        return c1 == c2 ? "selected" :"";
    });
}

function fnChecked(){
    Handlebars.registerHelper('cntChecked', function(c1) {
        return c1 == "0" ? "checked" :"";
    });
}

function fnSumParam3(){
    Handlebars.registerHelper('sumParam3', function(c1, c2, c3) {
        return c1+c2+c3;
    });
}

function fnEquals(){
    Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
        if(arg1 !== undefined){
            arg1 = arg1.trim();
        }
        if(arg2 !== undefined){
            arg2 = arg2.trim();
        }
        return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
    });
}

function fnIsPass(){
    Handlebars.registerHelper('isPass', function(providerId, options) {
        if(providerId !== undefined){
            providerId = providerId.trim();
        }  
        return providerChk.isPass(providerId) ? options.fn(this) : options.inverse(this);
    });
}
function fnIsNaver(){
    Handlebars.registerHelper('isNaver', function(providerId, options) {
        if(providerId !== undefined){
            providerId = providerId.trim();
        }  
        return providerChk.isNaver(providerId) ? options.fn(this) : options.inverse(this);
    });
}
function fnIsKb(){
    Handlebars.registerHelper('isKb', function(providerId, options) {
        if(providerId !== undefined){
            providerId = providerId.trim();
        }  
        return providerChk.isKb(providerId) ? options.fn(this) : options.inverse(this);
    });
}
function fnInputPassTypeByBrower(){
    Handlebars.registerHelper('inputPassTypeByBrower', function(options) {
        var inputYype = "type='number'";
        if(!device.isMobileUI()){
            return "type='password'"
        }
        return inputYype;
    });
}
function fnInputNumberByBrower(){
    Handlebars.registerHelper('inputNumberByBrower', function(options) {
        var inputYype = "type='number'";
        if(!device.isMobileUI()){
            return "type='text'"
        }
        return inputYype;
    });
}

function fnIsMobile(){
    Handlebars.registerHelper('isMobile', function(options) {
        return (device.isMobileUI()) ? options.fn(this) : options.inverse(this);
    });
}
function fnIsmTranskey(){
    Handlebars.registerHelper('ismTranskey', function(options) {
        return (Config.mTranskey.use) ? options.fn(this) : options.inverse(this);
    });
}
function fnIsEntSimpleAuth(){
    Handlebars.registerHelper('isEntSimpleAuth', function(options) {
        return Provider.contentInfo.signType === "ENT_SIMPLE_AUTH" ? options.fn(this) : options.inverse(this);
    });
}
function fnMath(){
    Handlebars.registerHelper("math", function(lvalue, operator, rvalue, options) {
        lvalue = parseFloat(lvalue);
        rvalue = parseFloat(rvalue);
        var result = {
            "+": lvalue + rvalue
        }[operator]
        return result;
    });
}

function fnIfHidden(){
    Handlebars.registerHelper('ifHidden', function(arg1, options) {
        return (!arg1) ? options.fn(this) : options.inverse(this);
    });
}
function fnIfNotUndefindedEmpty(){
    Handlebars.registerHelper('ifNotUndefindedEmpty', function(arg1, options) {
        if(arg1 == ""){
            return options.fn(this)
        }
        if(arg1 === undefined){
            return options.inverse(this);
        }
        return options.fn(this)
    });
}
function fnProviderAltNm(){
    Handlebars.registerHelper('providerAltNm', function(arg1, options) {
        var result = "";
        if(providerChk.isKakao(arg1)){
            result = "TALK- 카카오톡"
        }else if(providerChk.isKakaoPay(arg1)){
            result = "카카오페이"
        }else if(providerChk.isKb(arg1)){
            result = "KB 국민은행"
        }else if( providerChk.isNaver(arg1)){
            result = "NAVER"
        }else if( providerChk.isPass(arg1)){
            result = "PASS 휴대전화 인증"
        }else if( providerChk.isPayco(arg1)){
            result = "PAYCO"
        }else if( providerChk.isSamsung(arg1)){
            result = "SAMSUNG PASS"
        }else if( providerChk.isToss(arg1)){
            result = "토스"
        }else{
            result = ""
        }
        return result 
    });
}

export const helper = {
    init : function(){
        fnChecked();
        fnSelected();
        fnEquals();
        fnSumParam3();
        fnInputPassTypeByBrower();
        fnInputNumberByBrower();
        fnIsMobile();
        fnMath();
        fnIsPass();
        fnIsKb();
        fnIfHidden();
        fnIfNotUndefindedEmpty();
        fnIsmTranskey();
        fnIsEntSimpleAuth();
        fnIsNaver();
        fnProviderAltNm();
    }
}